import { NO_APLICA } from './constants'
import type { ClickEventParams, EcommerceItem } from './types'

/**
 * `module_name`/`module_type` del `click` de card de producto en los listados de
 * la PDP (`Grid relacionados.csv` → "Clic en card de producto relacionado" y
 * `Grid destacados.csv` → "Clic en card de producto destacado": ambos fijan
 * `click_type=card`, `module_name=productos_localizados`, `module_type=product_card`).
 */
export const PRODUCT_CARD_CLICK_MODULE_NAME = 'productos_localizados'
export const PRODUCT_CARD_CLICK_MODULE_TYPE = 'product_card'

/**
 * Los 12 parámetros fijos del `click` de card de producto. `link_text` es el
 * nombre del evento ya slugificado (`item.item_name`): el CSV solo trae
 * `productos_localizados` de ejemplo (copia del módulo), pero la variable es
 * `{{link_text}}`, el texto del enlace clicado.
 */
export function buildProductCardClick(item: EcommerceItem, href: string): ClickEventParams {
  return {
    click_type: 'card',
    click_subtype: NO_APLICA,
    link_text: item.item_name,
    link_url: href,
    link_domain: NO_APLICA,
    module_name: PRODUCT_CARD_CLICK_MODULE_NAME,
    module_type: PRODUCT_CARD_CLICK_MODULE_TYPE,
    nav_level: NO_APLICA,
    nav_path: NO_APLICA,
    action_detail: NO_APLICA,
    action_value: NO_APLICA,
    action_context: NO_APLICA,
  }
}
